export function mapValues(values, key, factor, check) {
    return values.map((value) => {
        return {
            ...value,
            ...(check(value) && {
                [key]: value.absolute * factor,
            }),
        };
    });
}
//# sourceMappingURL=mapValues.js.map